<template>
  <div class="ex-propose-inspection-tools-banner">
    <!-- Microlearning Video Section -->
    <div class="ex-propose-inspection-tools-banner-item">
      <div class="ex-propose-inspection-tools-banner-icon">
        <Icon name="microlearning_icon" />
      </div>
      <div class="ex-propose-inspection-tools-banner-right">
        <div>
          <p class="ex-propose-inspection-tools-banner-title">
            Propose a microlearning video with inspection instructions and a tutorial
          </p>
          <p
            class="ex-propose-inspection-tools-banner-description ex-propose-inspection-tools-banner-description-full"
          >
            Microlearning videos are short, targeted resources that help employees quickly grasp key
            concepts and best practices. Once you upload a video, you can use IQ AI to extract
            inspection instructions and tutorial steps.
          </p>
        </div>
        <div class="ex-propose-inspection-tools-banner-buttons">
          <StandardButton
            size="small"
            variant="secondary"
            label="Upload Microlearning Video"
            @click="handleMicrolearningUploadClick"
          ></StandardButton>
          <StandardButton
            size="small"
            variant="primary"
            label="Task an Employee to upload a video"
            @click="handleTaskEmployeeClick"
          ></StandardButton>
        </div>
      </div>
    </div>

    <!-- Instructions Section -->
    <div class="ex-propose-inspection-tools-banner-item">
      <div class="ex-propose-inspection-tools-banner-icon">
        <Icon name="instructions_icon" />
      </div>
      <div class="ex-propose-inspection-tools-banner-right">
        <div>
          <p class="ex-propose-inspection-tools-banner-title">Propose text inspection instructions</p>
          <p class="ex-propose-inspection-tools-banner-description">
            Instructions enable coaches to rigorously inspect a checkpoint. In their absence,
            coaches rely on personal judgment to interpret the criteria and assess readiness, which
            can lead to inconsistencies in inspection outcomes.
          </p>
          <p class="ex-propose-inspection-tools-banner-description">
            Instructions also help employees prepare more effectively for inspections by providing
            clarity on the criteria and how they will be inspected.
          </p>
        </div>
        <div class="ex-propose-inspection-tools-banner-buttons">
          <StandardButton
            size="small"
            variant="secondary"
            label="Propose"
            @click="handleProposeClick"
          ></StandardButton>
          <AskIQButton label="Suggest" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";
import AskIQButton from "@components/AskIQButton/AskIQButton.vue";
import Icon from "@components/icons/Icon.vue";
import StandardButton from "@components/StandardButton/StandardButton.vue";

// Emits
const emit = defineEmits([
  "microlearning-upload-click",
  "task-employee-click",
  "propose-click",
  "iq-suggest-click",
]);

const { proxy } = getCurrentInstance() ?? {};
const ideaMDP461Enabled = computed(() =>
  Boolean(proxy?.$store?.getters?.["featureFlags/ideaMDP461"])
);

const handleMicrolearningUploadClick = () => {
  emit("microlearning-upload-click");
};

const handleTaskEmployeeClick = () => {
  if (!ideaMDP461Enabled.value) return;
  emit("task-employee-click");
};

const handleProposeClick = () => {
  emit("propose-click");
};
</script>

<style>
.ex-propose-inspection-tools-banner {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ex-propose-inspection-tools-banner-item {
  display: flex;
  background-color: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border-radius: 8px;
  padding: 10px 8px 12px 8px;
  flex-direction: row;
}
.ex-propose-inspection-tools-banner-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 2px 0px #1018280d;
  padding: 10px 9px 9px 9.2px;
}
.ex-propose-inspection-tools-banner-right {
  position: relative;
  left: 15px;
}
.ex-propose-inspection-tools-banner-title {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #344054;
  margin-bottom: 2px !important;
}
.ex-propose-inspection-tools-banner-description {
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #475467;
  margin-bottom: 12px !important;
  width: 99%;
}
.ex-propose-inspection-tools-banner-description-full {
  width: 100%;
}
.ex-propose-inspection-tools-banner-buttons {
  display: flex;
  gap: 12px;
  margin-top: -2px;
}
</style>
